/** Schema id embedded in assistant JSON export/paste; keep in sync with Edge Function expectations. */
export const ROADMAP_ASSISTANT_SCHEMA = "efrf-roadmap-v1" as const;
